import * as React from 'react';
import type { SubjectCardProps } from '../SubjectCard/SubjectCard';
import { SubjectCard } from '../SubjectCard/SubjectCard';
import type { SubjectOverlayContentProps } from '../SubjectOverlayContent/SubjectOverlayContent';
import { SubjectOverlayContent } from '../SubjectOverlayContent/SubjectOverlayContent';
import { WithOverlay } from '~/Features/StudyPage/Campus/Components/Overlay/WithOverlay';
import type { StrictOmit } from '~/Partials/Utils/typeUtils';

type CombinedChildrenProps = StrictOmit<SubjectCardProps, 'onClick' | 'additionalAriaProps'> &
    StrictOmit<SubjectOverlayContentProps, 'shouldMakeRequest'>;

export interface SubjectCardWithOverlayProps extends CombinedChildrenProps {
    subjectOverlayLabel: string;
    closeOverlayLabel: string;
}

export const SubjectCardWithOverlay: React.FC<SubjectCardWithOverlayProps> = props => {
    const { subjectCode, subjectName, subjectOverlayLabel, closeOverlayLabel, ...restProps } = props;

    return (
        <WithOverlay
            key={subjectCode}
            overlayContent={(_, isOpen) => (
                <SubjectOverlayContent
                    {...restProps}
                    subjectCode={subjectCode}
                    subjectName={subjectName}
                    shouldMakeRequest={isOpen}
                />
            )}
            overlayLabel={subjectOverlayLabel}
            closeLabel={closeOverlayLabel}
        >
            {triggerButtonProps => {
                const { onClick, ...ariaProps } = triggerButtonProps;

                return (
                    <SubjectCard
                        {...restProps}
                        subjectCode={subjectCode}
                        subjectName={subjectName}
                        onClick={onClick}
                        additionalAriaProps={ariaProps}
                    />
                );
            }}
        </WithOverlay>
    );
};
